import { render, staticRenderFns } from "./main-navigation.vue?vue&type=template&id=626c15ca"
import script from "./main-navigation.vue?vue&type=script&lang=js"
export * from "./main-navigation.vue?vue&type=script&lang=js"
import style0 from "./main-navigation.vue?vue&type=style&index=0&id=626c15ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports